import {
  MANUFACTURING_ORDER_ALL,
  MANUFACTURING_ORDER_GET,
  MANUFACTURING_ORDER_POST,
  MANUFACTURING_ORDER_PUT,
  MANUFACTURING_ORDER_DEL,
  MANUFACTURING_ORDER_ERROR,
  MANUFACTURING_ORDER_LOADING,
} from '../../actions/types';

const initialState = {
  manufacturingOrder: null,
  isLoading: true,
  isCompleted: true,
};

export default function ManufacturingOrder(state = initialState, action) {
  switch (action.type) {
    case MANUFACTURING_ORDER_LOADING:
      return { isLoading: true, isCompleted: true };
    case MANUFACTURING_ORDER_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case MANUFACTURING_ORDER_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case MANUFACTURING_ORDER_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case MANUFACTURING_ORDER_POST:
      return { isLoading: false, isCompleted: true, ...action.payload };
    case MANUFACTURING_ORDER_PUT:
      return { isLoading: false, isCompleted: true };
    case MANUFACTURING_ORDER_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
